export const translationOverwrites = {
  en: {
    // lang
    user: {
      // chunk
      register: {
        // keys (nested)
        passwordMinRequirements:
          'Password must be eight characters minimum, with one uppercase letter, one number, one symbol'
      }
    },
    contactUs: {
      contactUs: {
        minLength: 'Minimum phone number length is {{minLength}}'
      }
    },
    accountSummary: {
      accountSummary: {
        id: 'ID',
        address: 'Address',
        noUnits: 'No Organizational Units Found',
        noDetail: 'No Details Found',
        b2bSelectorChanged: 'B2B selector switched successfully.'
      }
    },
    shipmentCreditClaim: {
      shipmentCreditClaim: {
        dispenserCreditId: 'Dispenser Credit Id',
        dateCreated: 'Date Created',
        creditRequestMethod: 'Credit Request Method',
        noShipmentCreditClaim: 'No Shipment Credit Claim Found',
        downloadCreditHistory: 'Download Credit History',
        CreditClaimcode: 'There is no credit claim for this code'
      }
    },
    dispenserShipment: {
      dispenserShipment: {
        id: 'Shipment ID',
        date: 'Date of Shipment',
        agreementNumber: 'Agreement Number',
        creditMemo: 'Credit memo',
        address: 'Shipment Address',
        type: 'Shipment Type',
        invoice: 'Invoice Number',
        status: {
          SHIPPED: 'Shipped',
          PLACED: 'Placed',
          CONFIRMED: 'Confirmed',
          COMPLETED: 'Completed',
          CANCELLED: 'Cancelled',
          BACK_ORDERED: 'Back Ordered',
          CANCELLING: 'Cancelling',
          IN_PROGRESS: 'In Progress',
          CHECKED_VALID: 'Checked Valid',
          CREATED: 'Created',
          B2B_PROCESSING_ERROR: 'Processing Error',
          REJECTED: 'Rejected',
          PARTIALLY_DELIVERED: 'Partially Delivered',
          DELIVERED: 'Delivered'
        },
        shipTo: {
          SHIP_TO_DISTRIBUTOR: 'Ship To Distributor',
          SHIP_TO_CUSTOMER: 'Ship To Customer',
          CREDIT_NOTE: 'Credit Note'
        },
        shipmentLineNumber: 'Shipment Line Number',
        quantityIssued: 'Quantity Issued',
        netValue: 'Net Value',
        gst: 'GST',
        downloadHistory: 'Download Shipments History',
        downloadEntries: 'Download Shipment Entries',
        downloadCreditHistory: 'Download Credit History',
        downloadCreditEntries: 'Download Credit Entries',
        materialNetValue: 'Material Net Value',
        materialStatus: 'Material Status',
        eta: 'In Stock From',
        quantityDispatched: 'Quantity Dispatched',
        quantityRemaining: 'Quantity Remaining',
        shipmentNumber: 'Dispenser Shipment #',
        orderDate: 'Dispenser Order Date',
        submittedDate: 'Submitted Date',
        poNumber: 'PO #',
        orderStatus: 'Order Status',
        dispenserShipTo: 'Ship To',
        productNumber: 'Product Number',
        productShortDescription: 'Product Short Description',
        etaDate: 'ETA Date',
        lineStatus: 'Line Status',
        orderedQuantity: 'Ordered Quantity',
        deliveredQuantity: 'Delivered Quantity',
        dispatchDate: 'Dispatch Date'
      }
    },
    imageLibrary: {
      imageLibrary: {
        download:
          'To download the full library of our Tork, Tena and Libra images, simply click on the download button. The images will be downloaded in a zip file.',
        downloadButton: 'Download zip file'
      }
    },
    shared: {
      shared: {
        termsOfUse: 'By logging in you agree to our',
        termsOfUseAgree: 'terms of use',
        sortBy: 'Sort By',
        select: 'Select',
        actions: 'Actions',
        details: 'Details',
        filterBy: 'Filter By',
        noEntries: 'No Entries Found',
        noAgreements: 'No Agreements Found',
        noClaims: 'No claims found',
        startDate: 'Start Date',
        endDate: 'End Date',
        name: 'Name',
        viewDetails: 'View Details',
        errorTryAgain: 'Error occurred. Try Again.',
        orderNumber: 'Order Number',
        email: 'Email',
        downloadCreditNote: 'Download Credit Note (PDF)',
        downloadDebitNote: 'Download Debit Note (PDF)',
        downloadNote: 'Download Note (PDF)',
        sort: {
          byDateCreated: 'Date Created',
          byName: 'Name',
          byCode: 'Code',
          byTotal: 'Total',
          byId: 'ID',
          byDate: 'Date',
          byOrderNumber: 'Order Number',
          byStatus: 'Status'
        },
        reason: 'Reason',
        uploadPhotoOrComment: 'Upload photo or comment',
        addComment: 'Add Comment',
        addPhotoOrComment: 'Add photo or comment',
        comment: 'Comment',
        commentPlaceHolder: 'Write your comment',
        comments: 'Comments',
        essityComment: 'Essity Comment',
        attachments: 'Attachments',
        enter: 'Enter',
        none: 'None',
        items: 'items',
        value: 'Value',
        status: 'Status',
        date: 'Date',
        sku: 'SKU',
        volume: 'Volume',
        total: 'Total',
        uom: 'Unit of measurement',
        price: 'Price',
        cancel: 'Cancel',
        close: 'Close',
        notAuthorized: 'You are not authorized to perform this action.',
        uploadImage: 'Upload image',
        backTo: {
          back: 'Back',
          dispensers: 'Back to Dispenser Agreements',
          dispenserDetails: 'Back To Dispenser Details',
          dispenserShipments: 'Back To Dispenser Shipments',
          priceSupportAgreement: 'Back To Agreements',
          rebateClaims: 'Back To Rebate Claims',
          creditClaims: 'Back To Credit Claims',
          placeOrder: 'Back to Order',
          orderHistory: 'Back to Order History',
          dispenserCreditClaim: 'Back to Dispenser Credit Claims',
          dispenserCreditClaimHistory: 'Back to Dispenser Credit Claim History'
        },
        error: {
          negativeQuantity: 'Quantity must be non-negative.',
          quantityMoreThanRemaining: 'Quantity entered should not be more than remaining.',
          noEndCustomerAddress: 'No EndCustomer address found.',
          noDistributorAddresses: 'No Distributor addresses found.',
          noSimulation: `You've encountered an issue! Please try again in a few minutes or contact our customer services desk if this issues persists.`,
          noDispenserCategory: `No dispenser category found.`,
          downloadAddressFormError: `Error downloading address form.`,
          orderAgain: 'Error occurred while Reordering.',
          notFound404: '404\nNot Found',
          quantityMoreThanDelivery: 'Quantity Entered is greater than Qty Delivered',
          quantityMoreThanOrdered: 'Quantity Entered is greater than Qty Ordered'
        },
        discontinuedProduct: {
          discontinuedTag: 'Discontinued',
          infoMessage: ' | See replacement product below'
        }
      }
    },
    dispenserAgreement: {
      dispenserAgreement: {
        creditClaimsHistory: 'View Credit Claims History',
        transactionHistory: 'Transaction History',
        createOrdersClaims: 'Create Orders/Claims',
        agreementNumber: 'Agreement Number',
        dateCreated: 'Date Created',
        endCustomerName: 'End Customer Name',
        endCustomerNumber: 'End Customer Number',
        endCustomerBN: 'End Customer ABN/NZBN',
        approvedAssets: 'Approved Assets',
        remainingQuantity: 'Remaining Quantity',
        placeOrder: 'Place Order',
        updateDispenserAgreement: 'Request a change',
        cancelDispenserAgreement: 'Cancel',
        cancelDispenserAgreementModalTitle: 'Cancel Agreement',
        cancelDispenserAgreementModalConfirmation: 'Are you sure you would like to request to cancel this agreement?',
        newAgreement: 'Create New Agreement',
        createDispenserCreditRequest: 'Create Dispenser Credit Request',
        materialNumber: 'Material Number',
        materialDescription: 'Material Description',
        approved: 'Approved',
        dispatched: 'Dispatched',
        remaining: 'Remaining',
        downloadCSV: 'Download Agreement (CSV)',
        endCustomerBNFull: 'End Customer ABN / Company Number',
        endUserNumber: 'End User Number',
        startDate: 'Start Date',
        endUserDescription: 'End User Description',
        endCustomerDescription: 'End Customer Description',
        agreementType: 'Agreement Type',
        freeOnLoan: 'Free on Loan Dispensers',
        services: 'Services',
        endCustomerInformation: 'End Customer Information',
        requesterInformation: 'Requester Information',
        termInformation: 'Free On Loan Terms & Conditions',
        termInfo: 'Term Information',
        yesNo: 'Yes, I can confirm',
        termInformationMessage:
          'Please confirm that the end user is aware of the requirement to use ' +
          'Australasia’s products in the dispensers provided free on loan. An Agreement outlining these obligations will be sent to the end user for their review and confirmation via DocuSign acceptance.',
        termInfoMessage:
          'Please confirm that the end user is aware of the requirement to use ' +
          '{{dispenser}} in the dispensers provided free on loan & a document to confirm the obligations will be sent.',
        assetSelection: 'Asset Selection',
        dispenserDisclaimer:
          'If you would like to request a dispenser not available on this page, please contact your Tork Sales rep for approval',
        review: 'Review',
        requesterName: 'Requester Name',
        addressLine1: 'Address Line 1',
        addressLine2: 'Address Line 2',
        distributionCompany: 'Distribution Company',
        abn: 'ABN/NZBN',
        postcode: 'Postcode',
        state: 'State',
        phoneNumber: 'Phone Number',
        businessName: 'Business Name',
        contactName: 'Contact Name',
        installer: 'Installer',
        installReason: 'Install Reason',
        requestApplicationDate: 'Request Application Date',
        commencementDate: 'Commencement Date',
        item: 'Item',
        itemNumber: 'Item Number',
        colour: 'Colour',
        system: 'System',
        systemType: 'System Type',
        quantity: 'Quantity',
        serviceTypeSelection:
          'An Aslaeo Care representative will be in contact within x days to finalise your agreement details',
        smartCareSelection: 'Smart care service is not yet available. Please select any other service.',
        requesterInfoMessage: 'These details have been pre-filled. To edit your details, please go to the ',
        assetRequestSubmitted: 'Your asset request has been submitted.',
        checkStatusButton: 'Check status of my agreements',
        salesOrganisation: 'Sales Organisation',
        shipToSelect: 'Ship To Selection',
        dispenserSelection: 'Dispenser Selection',
        invoiceNumber: 'Invoice Number',
        shipToAndDispenserSelection: 'Ship To and Dispenser Selection',
        addressSelection: 'Address Selection',
        requestCreditNote: 'Request Credit Note',
        shipEndUserDepot: 'Ship to End User Depot',
        shipDistributorDepot: 'Ship to Distributor Depot',
        shipment: 'Shipment',
        endUserAddress: 'End User Address',
        shipToAddress: 'Ship To Address',
        shipTo: 'Ship to',
        submitted: 'Submitted',
        thankYou: 'Thank you for submitting your credit request!',
        creditRequestItems: 'Credit Request Items',
        requestSubmitted: 'Your asset request has been submitted.',
        requestSubmitMessage:
          'Success! Thank you for your request, your reference number is {{referenceNumber}}.\nWe will process it within 48 hours.',
        SubmitMessage: 'Success! Thank you for your request. We will \n process it within 48 hours.',
        updateMessage: 'Success! Thank you for your request.\nWe will process it within 48 hours.',
        updateAgreementMessage:
          'You will receive a confirmatiom email when we have completed the update to your agreement.',
        confirmTermInformation: 'Yes, I confirm',
        searchEndCustomer: 'Search End Customer',
        placed: 'Submitted',
        accepted: 'Accepted',
        rejected: 'Rejected',
        pending: 'Pending',
        expired: 'Expired',
        reviewing: 'Reviewing',
        waitingSignedAgreement: 'Waiting on Signed Agreement',
        cancelled: 'Cancelled',
        newClaim: {
          title: 'New Dispenser Credit Request',
          downloadNewForm: 'Download Dispenser Credit Request Form',
          downloadNewFormDescription:
            'To update a dispenser credit request or add a new request please download the dispenser credit request form. This form is an editable file and can be updated from your computer. Once you have completed the form, save the file, and upload it using the Upload button.',
          downloadForm: 'Download Form',
          uploadForm: 'Upload Form',
          uploadSuccess: 'Upload was successful.',
          uploadTitle: 'Upload Dispenser Credit Request Form',
          uploadNewFormDescription: 'Please upload your dispenser credit request form using the Upload Form button.',
          uploadSuccessCreditRequest:
            'Your request for a credit note is currently being processed. This can take up to 30 minutes.' +
            '\nOnce the credit request has been processed, you can access all of your historical credit claims by ',
          uploadFailed:
            'Your upload file was unsuccessful. The format of the Credit Request Form needs to be CSV (comma delimited). Please resave your file in this format and resubmit.',
          fileFormatAdvise:
            'Please note that the file format needs to be CSV (comma delimited). Please ensure the file is in this format before submitting.',
          clickingHere: 'Clicking Here'
        },
        placeHolder: {
          installer: 'Self, Dist, AC, FM',
          installReason: 'Reason for install:',
          installReasonHint: `1. Replacement for Broken Tork Dispensers
          2. Replacement for Non-Tork Dispensers
          3. New Installation Site
          4. Additional Dispenser for New Area
          5. Update Current Tork Dispenser`,
          freeOnLoan: `Use this selection to create your
                      Free-On-Loan agreement request for our {{dispenser}}.`
        },
        minimumDispatchText: 'Standard lead time & cut offs apply - ',
        minimumDispatchTime: 'Standard lead time & cut offs apply - minimum {{time}}hrs for dispatch',
        purchaseOrderNumber: 'Purchase Order Number',
        downloadOpenShipments: 'Download Open FOL Orders',
        continueToUpdate: 'Continue to update',
        queries: 'For any queries, please email dispensers.anz@essity.com',
        updateExplanation:
          'To request an increase in volume of an existing SKU or to add a new dispenser to this agreement, please adjust the existing volume. Please note, if you wish to delete a SKU from an agreement, please email dispensers.anz@essity.com.',
        updateExample:
          'You would like to request to increase the volume of Tork Air Freshener from 10 to 15 (an increase of 5). The form will display the existing 10 and you will need to adjust by changing the volume to 15.',
        statusChangeWarning:
          'Please note that the status of the agreement will change to "Reviewing" while Essity is reviewing your request.',
        cancellationSubmitted: 'Your cancellation request has been received.',
        cancellationSubmitMessage:
          'Thank you for your cancellation requestion for dispenser agreement {{agreementNumber}}.',
        cancellationSubmitMessage2: 'We will process your request within 48 hours.'
      }
    },
    priceSupportAgreement: {
      priceSupportAgreement: {
        agreementNumber: 'Agreement Number',
        endUserName: 'End User Name',
        endUserNumber: 'End User Number',
        distributorEndUserAccount: 'Distributor End User Account#',
        startDate: 'Start Date',
        endDate: 'End Date',
        division: 'Division',
        status: 'Status',
        downloadAgreementsHistory: 'Download Agreements History',
        downloadClaimsCSV: 'Download Agreement Details',
        placed: 'Placed',
        accepted: 'Accepted',
        rejected: 'Rejected',
        pending: 'Pending',
        expired: 'Expired',
        downloadCSV: 'Download Agreement (CSV)',
        termsConditions: 'Terms & Conditions',
        sku: 'SKU',
        skuDescription: 'SKU Description',
        description: 'Description',
        productType: 'Product Type',
        netInvoiceValue: 'Net Invoice Value',
        netInvoicePrice: 'Net Invoice Price',
        rebates: 'Rebates',
        endUserPrice: 'End User Price',
        dbp: 'DBP',
        endCustomerPrice: 'End Customer Price',
        volumeCommitment: 'Volume Commitment (Cases)',
        accept: 'Accept',
        reject: 'Reject',
        acceptAgreement: 'Accept Agreement',
        t_c: 'T&C',
        acceptor: 'Acceptor',
        messageTC: 'By clicking accept, you agree to the',
        agreementNUM: 'Agreement #',
        reason: 'Reason',
        reasonPlaceholder: 'Enter reason',
        rejectAgreement: 'Reject Agreement',
        accountNumberUpdated: 'Account Number updated successfully.',
        postCode: 'Postcode',
        state: 'State',
        addressLine1: 'Address Line 1',
        addressLine2: 'Address Line 2',
        search: 'Search End Customer',
        searchHint: 'Enter end customer account number'
      }
    },
    productUpdates: {
      productUpdates: {
        information:
          'This page includes announcements about exciting new product lauches, along with product changes, replacements, and deletions. Use de dropdown.',
        searchHint: 'Search SKU Code',
        australia: 'Australia',
        newZealand: 'New Zealand',
        changeType: 'Change Type',
        productCode: 'Product Code',
        productName: 'Product Name',
        replacementCode: 'Replacement Code',
        esitmatedTime: 'Est. Time',
        downloadPDF: 'Download PDF'
      }
    },
    importCart: {
      importCart: {
        title: 'The imported file will be used to create a saved cart.',
        description: 'The text file should list the product SKUs and case quantities in the following format:',
        quantity: 'SKU, Quantity (case)',
        size: 'Maximum file size: 10.00 KB',
        chooseFileTitle: 'Select a file to upload. The file must be a text file with extension CSV.',
        chooseFile: 'Choose File',
        import: 'Import',
        noSavedCarts: 'No Saved Carts Found',
        code: 'Code',
        dateCreated: 'Date Created',
        exportCart: 'Export Cart',
        totalPrice: 'Total Price',
        restore: 'Restore',
        cartImported: 'Cart imported successfully.',
        downloadTemplate: 'Download Template'
      }
    },
    creditClaims: {
      creditClaims: {
        datePlaced: 'Date placed',
        AsaleoCreditNumberReference: 'Asaleo Credit Number Reference',
        CustomerClaimNumberReference: 'Customer Claim Number Reference',
        ClaimNumber: 'Claim Number',
        OrderNumber: 'Order Number',
        CreditValue: 'Credit Value (ex GST)',
        CreditNoteNumber: 'Credit Note Number',
        invoiceNumber: 'Invoice Number',
        status: 'Status',
        value: 'Value',
        placed: 'Placed',
        accepted: 'Accepted',
        rejected: 'Rejected',
        pending: 'Pending',
        submitnewClaim: 'Submit new claim',
        createNewClaim: 'Create new claim from Order History',
        reasonForClaim: 'Reason for claim',
        restockingFeeMessage: 'Re-stocking fees may apply',
        restockingFeeNote: 'Note: Stock maybe required to be returned',
        shortAndOverSuppliedTip: 'Tip: I did not receive my full order and received other items',
        reasonPhotoMessage: 'This reason will require photo evidence',
        submitnewClaimWithOrder: 'Submit a new claim with order number',
        submitnewClaimWithoutOrder: 'Submit a new claim without order number',
        didYouReceive: 'Did you receive something else instead?',
        reasons: {
          SHORT_OVER_SUPPLIED: 'Short and Over Supplied',
          RECEIVED_DAMAGED: 'Received damaged',
          SHORT_SUPPLIED: 'Short supplied',
          OVER_SUPPLIED: 'Over supplied',
          ASALEO_KEYING_DISCREPANCY: 'Keying discrepancy',
          EXPIRED_STOCK: 'Expired stock',
          DAMAGED_STOCK: 'Damaged stock',
          FAULTY_STOCK: 'Faulty stock',
          NOT_REQUIRED: 'Not required',
          REQUEST_RETURN: 'Request return of stock',
          OTHER: 'Other'
        },
        order: {
          material: 'Material',
          description: 'Description',
          deliveryDate: 'Delivery Date',
          orderedQTY: 'Ordered QTY',
          deliveredQTY: 'Delivered QTY',
          claimQTY: 'Claim QTY',
          claimValue: 'Total (EX GST)',
          // claimValue: 'Claim Value (ex GST)',
          addPhotoOrComment: 'Add photo or comment',
          commentText: 'Please include comments (required)',
          shortOversuppliedText: 'were you charged for the oversupplied product?',
          itemValue: 'Item Value',
          totalValue: 'Total Value',
          deliveryInstructions: 'Delivery Instructions'
        },
        statuses: {
          APPROVED: 'Approved',
          FOR_APPROVAL: 'For Approval',
          REJECTED: 'Rejected',
          PENDING: 'Pending',
          UNDER_REVIEW: 'Under Review',
          SUBMITTED: 'Submitted',
          IN_PROCESS: 'In Process',
          ACTION_REQUIRED: 'Action Required',
          COMPLETED: 'Completed',
          REOPENED: 'Reopened',
          DUPLICATE: 'Duplicate',
          CANCELLED: 'Cancelled'
        },
        details: 'Credit Claim Details',
        downloadResolutionDocument: 'Download Resolution Document',
        successMessage: 'Thank You, Your claim/s has been submitted successfully.',
        referenceNote: 'Please note your following claim reference/s',
        confirmationMessage: 'We have sent a confirmation email to',
        checkStatus: 'You can check the status of your claim by navigating to credit claim history page',
        commentsHint: 'Maximum character limit is 220. You have {{count}} characters left',
        accept: 'Yes, I have uploaded the photos and/or added comments to support my claim',
        reviewed: 'Yes, I have reviewed my claim and am happy to proceed',
        yes: 'Yes',
        no: 'No',
        viewAttachments: 'View Attachments'
      }
    },
    rebateClaims: {
      rebateClaims: {
        claimMonth: 'Claim Month',
        downloadDetailsCsv: 'Download claim details (CSV)',
        distributorNumber: 'Distributor number',
        endCustomerNumber: 'End customer number',
        distributorEndCustomerNumber: 'Distributor end customer number',
        newClaim: {
          newPriceSupportClaim: 'Manage Price Support Claim',
          downloadNewForm: 'Download price support claim form',
          downloadNewFormDescription:
            'To update a price support claim or add a new price support claim please download the price support claim form. This form is an editable file and can be updated from your computer. Once you have completed the form, save the file, and upload it using the Upload Claim button.',
          downloadForm: 'Download claim form',
          uploadForm: 'Upload form',
          uploadSuccess: 'Upload price support claim form was successful',
          uploadtitle: 'Upload price support claim form',
          uploadNewFormDescription: 'Please upload your price support claim form using the Upload Form button.',
          uploadFailed:
            'Your upload file was unsuccessful. The format of the Rebate Claim Form needs to be CSV (comma delimited). Please resave your file in this format and resubmit.',
          fileFormatAdvise:
            'Please note that the file format needs to be CSV (comma delimited). Please ensure the file is in this format before submitting.',
          monthSelectionExplained:
            'Please select the month that the rebate relates to and this will be visible on the Rebate Claims History page for your reference.'
        },
        rebateClaimHistory: {
          downloadClaimCSV: 'Download Details (CSV)',
          claimId: 'Claim ID',
          claimDate: 'Claim Date',
          gst: 'GST',
          value: 'Value (ex GST)'
        }
      }
    },
    etaGuide: {
      etaGuide: {
        au:
          'Unless you have advised customer service to strictly use the required delivery dates on your orders, they will default to be dispatched in 2 business days.\n\n' +
          'The cut off time for orders is noon in your location. (other than SA which is 11:30).\n\n' +
          'Below is a reference table on the lead time to reach your location to assist with your planning.\n' +
          '(note that the goods will be invoiced when they leave our Distribution Centers)',
        hint: '*seasonal adjustments over the Christmas/New Year period may apply.',
        nzTime: 'The cut off time for orders is 11.30 am NZT.',
        nz: 'Unless you have advised Customer Service to strictly use the required delivery dates on your orders, they will default to next working day delivery.',
        nzLowerNorth:
          '**Orders supplied to the lower north island from the Penrose (AKL) DC will have a two day lead time.',
        nzNWFS: 'New World & Four Square stores have nominated delivery days. ',
        nzFSNI:
          'If your order is received the day prior to a non delivery day it will be held by FSNI until next scheduled delivery.',
        nzPD: 'Permanent delivery time slot requests will be reviewed on a case by case basis.',
        nzInvoice: 'Deliveries will be invoiced when they leave our Distribution Centre.'
      }
    },
    creditHold: {
      creditHold: {
        message: `You're on Credit Hold.`
      }
    },
    totalAmount: {
      totalAmount: {
        message: `The minimum value of your order needs to be greater than $ {{amount}}. Please adjust your order.`
      }
    },
    excludedItems: {
      excludedItems: {
        message: 'Some of the items could not be reordered. Click to know the details.'
      }
    },
    modals: {
      modals: {
        orderAgain: {
          title: 'Order Again',
          msg: 'Your current cart items will be removed if you continue with this option.',
          extra: 'This operation can not be undone.',
          yes: 'Yes, Reorder'
        },
        restoreCart: {
          title: 'Import cart',
          msg: 'Your current cart items will be removed if you continue with this option.',
          extra: 'This operation can not be undone.',
          yes: 'Yes, Import'
        }
      }
    },
    myAccount: {
      orderHistory: {
        ETA: 'ETA',
        inStockFrom: 'In Stock From',
        viewOrderDetails: 'View order details',
        orderAgain: 'Order again',
        download: 'Download',
        sortBy: 'Sort by',
        filterBy: 'Filter by Order',
        actions: 'Actions',
        submitClaim: 'Submit claim',
        search: 'Search',
        searchHint: 'Enter Order or PO or Invoice',
        downloadCSV: 'Download Open Orders (CSV)',
        lineStatusFilter: 'Line status filter',
        filterOrderLines: 'Filter order lines',
        orderDate: 'Order Date',
        orderId: 'ORDER #',
        purchaseOrderNumber: 'PO #',
        status: 'Status',
        total: 'TOTAL'
      },
      updatePasswordForm: {
        passwordMinRequirements:
          'Password must be eight characters minimum, with one uppercase letter, one number, one symbol'
      },
      notificationPreference: {
        message: 'Manage your email and notification preferences here. Your email notifications are sent to:'
      },
      orderDetails: {
        statusDisplay_CHECKED_VALID: 'Placed',
        statusDisplay_CREATED: 'Created',
        statusDisplay_CONFIRMED: 'Confirmed',
        statusDisplay_BACK_ORDERED: 'Back-ordered',
        statusDisplay_B2B_PROCESSING_ERROR: 'Processing error',
        statusDisplay_CANCELLING: 'Cancelling',
        statusDisplay_COMPLETED: 'Completed',
        statusDisplay_CANCELLED: 'Cancelled',
        statusDisplay_REJECTED: 'Rejected',
        statusDisplay_IN_PROGRESS: 'In Progress',
        statusDisplay_SHIPPED: 'Shipped',
        statusDisplay_PARTIALLY_DELIVERED: 'Partially delivered',
        statusDisplay_DELIVERED: 'Delivered',
        statusDisplay_PLACED: 'Placed',
        orderId: 'Order #',
        status: 'status',
        methodOfPayment: 'Method of Payment'
      }
    },
    address: {
      addressCard: {
        setAsDefault: 'Set this as my default address',
        shippingAddress: 'Shipping address',
        billingAddress: 'Billing address',
        defaultAddress: 'Default address'
      },
      address: {
        title: 'Manage your delivery address',
        downloadFormTitle: 'Download address form',
        downloadFormText:
          'To update or add an additional delivery address, please complete the form via the link below. Once you have submitted the form, \n' +
          'it will be reviewed by our Logistics and Accounts Teams. The address will appear below when it is approved and is ready to be used. \n' +
          'Our Customer Experience Team will also confirm via email when the process has been completed.',
        downloadFormNote:
          "Please allow a minimum of 2 weeks' from form submission before placing an order for delivery to the new/updated address.",
        downloadForm: 'Supply Chain Form',
        shippingAddresses: 'Shipping addresses',
        billingAddresses: 'Billing addresses',
        uploadSuccessful: 'Address form uploaded successfully',
        uploadFail: 'Address form failed to upload. Please try again.'
      }
    },
    common: {
      httpHandlers: {
        badRequestPleaseLoginAgain: '{{ errorMessage }}. Please login again or contact customer service.'
      },
      formErrors: {
        invalidPhoneNumber: 'Invalid phone number',
        maxPhoneNumber: 'Max phone number length is 12 digits.'
      }
    },
    cart: {
      orderCost: {
        salesTax: 'GST:'
      },
      cart: {
        recalculate: 'Recalculate Cart',
        saveCart: 'Save Cart',
        saveCartSuccess: 'Your shopping cart has been saved'
      }
    },
    product: {
      TabPanelContainer: {
        tabs: {
          ProductDeliveryTabComponent: 'Delivery details',
          EnvironmentalInfoTabComponent: 'Environmental information',
          ProductDocumentsTabComponent: 'Download',
          noEnvironmentalInfo: 'No environmental information for this product'
        }
      },
      addToCart: {
        lowStock: 'Low Stock',
        continueShopping: 'Continue Shopping'
      },
      productSummary: {
        articleNumber: 'Article Number',
        downloadProductSpecifications: 'Download Product Specifications'
      }
    },
    checkout: {
      checkoutShipping: {
        specialInstructions: 'Special Instructions',
        specialInstructionsHint: 'Maximum character limit is 200. You have {{count}} characters left',
        requestedDeliveryDate: 'Requested Dispatch Date',
        preferredDate: 'Preferred Dispatch Date',
        preferredDateHint:
          'Orders placed after cut-off will default to next available dispatch date after the order has been submitted',
        dispenserPreferredDateHint:
          'Dispenser orders placed after cut-off will default to next available dispatch date after the order has been submitted'
      },
      checkoutAddress: {
        noAddresses: 'No address found'
      },
      checkoutProgress: {
        deliveryMode: 'Delivery Details'
      },
      checkout: {
        backToCart: 'Back To Cart'
      }
    },
    checkoutAddress: {
      checkoutAddress: {
        noAddresses: 'No address found',
        shippingAddress: 'Shipping Address',
        selectYourShippingAddress: 'Select your Shipping Address'
      }
    },
    checkoutReview: {
      checkoutReview: {
        review: 'REVIEW',
        confirmThatRead: 'I am confirming that I have read and agreed with the',
        termsAndConditions: 'Terms & Conditions',
        placeOrder: 'Place Order'
      }
    },
    checkoutProgress: {
      checkoutProgress: {
        methodOfPayment: 'Method of Payment',
        deliveryAddress: ' Shipping Address',
        reviewOrder: 'Review Order'
      }
    },
    checkoutPO: {
      checkoutPO: {
        poNumber: 'Purchase order number (optional)',
        placeholder: 'Enter P.O'
      }
    },
    cartItems: {
      cartItems: {
        itemPrice: 'Item price',
        quantity: 'Qty',
        total: 'Total',
        cartTotal: 'Cart total',
        description: 'Description',
        id: 'ID',
        numberOfUOMperPallet: 'Pallet\n({{ fullPallet }} Cases)',
        numberOfUOMperLayer: 'Layer\n({{ fullLayer }} Cases)',
        updateToFullPallet: 'Add {{ fullPallet }} more cases to make a full pallet',
        updateToFullLayer: 'Add {{ fullLayer }} more cases to make a full layer'
      }
    },
    checkoutShipping: {
      checkoutShipping: {
        specialInstructions: 'Special Instructions',
        poNumber: 'Purchase Order Number',
        requestedDeliveryDate: 'Requested Dispatch Date',
        preferredDate: 'Preferred Dispatch Date',
        preferredDateHint:
          'Orders placed after cut-off will default to next available dispatch date after the order has been submitted',
        specialInstructionsHint: 'Maximum character limit is 200. You have {{count}} characters left',
        dispenserPreferredDateHint:
          'Dispenser orders placed after cut-off will default to next available dispatch date after the order has been submitted'
      }
    },
    orderCost: {
      orderCost: {
        subtotal: 'Subtotal after discounts:',
        salesTax: 'GST:',
        total: 'Total:',
        orderSummary: 'ORDER SUMMARY'
      }
    },
    cartDetails: {
      cartDetails: {
        cartName: 'Cart #',
        proceedToCheckout: 'Proceed to Checkout '
      }
    },
    checkoutOrderConfirmation: {
      checkoutOrderConfirmation: {
        confirmationOfOrder: 'Confirmation of Order:',
        thankYou: 'Thank you for your order!',
        orderItems: 'Order Items'
      }
    },
    searchBox: {
      input: {
        placeholder: 'Search here...'
      }
    },
    order: {
      orderHistory: {
        ETA: 'ETA',
        inStockFrom: 'In Stock From',
        viewOrderDetails: 'View order details',
        orderAgain: 'Order again',
        download: 'Download',
        sortBy: 'Sort by',
        filterBy: 'Filter by Order',
        actions: 'Actions',
        submitClaim: 'Submit claim',
        search: 'Search',
        searchHint: 'Enter Order or PO or Invoice',
        downloadCSV: 'Download Open Orders (CSV)',
        lineStatusFilter: 'Line status filter',
        filterOrderLines: 'Filter order lines',
        orderDate: 'Order Date',
        orderId: 'ORDER #',
        purchaseOrderNumber: 'PO #',
        status: 'Status',
        total: 'TOTAL',
        sortByMostRecent: 'Sort by most recent'
      },
      orderDetails: {
        statusDisplay_CHECKED_VALID: 'Placed',
        statusDisplay_CREATED: 'Created',
        statusDisplay_CONFIRMED: 'Confirmed',
        statusDisplay_BACK_ORDERED: 'Back-ordered',
        statusDisplay_B2B_PROCESSING_ERROR: 'Processing error',
        statusDisplay_CANCELLING: 'Cancelling',
        statusDisplay_COMPLETED: 'Completed',
        statusDisplay_CANCELLED: 'Cancelled',
        statusDisplay_REJECTED: 'Rejected',
        statusDisplay_IN_PROGRESS: 'In Progress',
        statusDisplay_SHIPPED: 'Shipped',
        statusDisplay_PARTIALLY_DELIVERED: 'Partially delivered',
        statusDisplay_DELIVERED: 'Delivered',
        statusDisplay_PLACED: 'Placed',
        orderId: 'Order #',
        status: 'status',
        methodOfPayment: 'Method of Payment'
      }
    }
  }
}
